export default __webpack_public_path__ + "static/media/Kothian Battle Helm.cc7679df.jpg";